import Constant from '@/const';
import axios from 'axios';

const exportDataVisits = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/report/visitors/export'),
      {
        params,
        responseType: 'blob',
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default exportDataVisits;
